var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-group d-flex justify-content-between align-items-center"},[_c('b-button',{staticClass:"d-inline font-weight-bold form-control h-100 px-9 py-4 my-3 mr-2 font-size-3",on:{"click":function($event){return _vm.$emit('change-mode', 'welcome')}}},[_vm._v(" Trở về ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }